module.exports = __webpack_public_path__ + "static/media/minimal.1823da4b.png";